// ═══════════════════════════════════════════════════════════════
// V·IANet Governance — useProcessNavigation hook
// Navigation helpers for process map levels
// ═══════════════════════════════════════════════════════════════

import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

export function useProcessNavigation() {
  const navigate = useNavigate();

  const goToLevel1 = useCallback(() => {
    navigate('/process-map');
  }, [navigate]);

  const goToLevel2 = useCallback(
    (groupId: number, tipologia?: string) => {
      const params = tipologia ? `?tip=${tipologia}` : '';
      navigate(`/process-map/group/${groupId}${params}`);
    },
    [navigate],
  );

  const goToLevel3 = useCallback(
    (processId: string) => {
      navigate(`/process-map/process/${processId}`);
    },
    [navigate],
  );

  const goToProcessSheet = useCallback(
    (codigo: string) => {
      navigate(`/proceso/${codigo}/ficha`);
    },
    [navigate],
  );

  return { goToLevel1, goToLevel2, goToLevel3, goToProcessSheet };
}
